import { useEffect, useState } from "react";
import { X, ChevronLeft, ChevronRight, Camera } from "lucide-react";
import api, { API } from "../lib/api";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

export const galleryUrl = (fileId) => `${API}/files/${fileId}/download`;

export default function TeamGallery() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  if (items.length === 0) return null;
  const cur = idx !== null ? items[idx] : null;
  const step = (d) => setIdx((i) => (i + d + items.length) % items.length);

  return (
    <section data-testid="team-gallery" className="py-14 md:py-20 border-t border-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold flex items-center gap-2"><Camera className="w-4 h-4" /> Our Team &amp; Fleet</div>
        <h2 className="mt-3 text-3xl md:text-4xl font-bold uppercase display text-white">Meet the crew behind every stop.</h2>
        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map((it, i) => (
            <button
              key={it.id}
              data-testid={`gallery-item-${it.id}`}
              onClick={() => setIdx(i)}
              className={`group relative overflow-hidden rounded-xl border border-slate-800 bg-slate-900 text-left ${i % 5 === 0 ? "col-span-2 row-span-2 aspect-square" : "aspect-square"}`}
            >
              <img src={galleryUrl(it.file_id)} alt={it.caption || "Integrity Delivered team"} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              {it.caption && (
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-slate-950/90 to-transparent p-3 text-xs text-slate-100 opacity-0 group-hover:opacity-100 transition-opacity">{it.caption}</div>
              )}
            </button>
          ))}
        </div>
      </div>

      {cur && (
        <Dialog open onOpenChange={(o) => !o && setIdx(null)}>
          <DialogContent data-testid="gallery-lightbox" className="max-w-5xl bg-slate-950 border-slate-800 p-0 overflow-hidden [&>button]:hidden">
            <DialogTitle className="sr-only">{cur.caption || "Team photo"}</DialogTitle>
            <div className="relative bg-black flex items-center justify-center max-h-[80vh]">
              <img src={galleryUrl(cur.file_id)} alt={cur.caption || ""} className="max-h-[80vh] w-auto object-contain" />
              <button data-testid="gallery-close" onClick={() => setIdx(null)} className="absolute top-3 right-3 w-9 h-9 rounded-full bg-slate-900/80 text-white flex items-center justify-center hover:bg-amber-500 hover:text-slate-950"><X className="w-4 h-4" /></button>
              {items.length > 1 && (
                <>
                  <button data-testid="gallery-prev" onClick={() => step(-1)} className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-slate-900/80 text-white flex items-center justify-center hover:bg-amber-500 hover:text-slate-950"><ChevronLeft className="w-5 h-5" /></button>
                  <button data-testid="gallery-next" onClick={() => step(1)} className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-slate-900/80 text-white flex items-center justify-center hover:bg-amber-500 hover:text-slate-950"><ChevronRight className="w-5 h-5" /></button>
                </>
              )}
            </div>
            {cur.caption && <div className="p-4 text-sm text-slate-200 border-t border-slate-800">{cur.caption}</div>}
          </DialogContent>
        </Dialog>
      )}
    </section>
  );
}
